import { render } from "./News14.vue?vue&type=template&id=2aefcf1c&scoped=true"
import script from "./News14.vue?vue&type=script&lang=js"
export * from "./News14.vue?vue&type=script&lang=js"

import "./News14.vue?vue&type=style&index=0&id=2aefcf1c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aefcf1c"]])

export default __exports__